/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Tatsachlichearbeitstageindiesemzeitraum4Inputs */



/**

* @param {_Field_Tatsachlichearbeitstageindiesemzeitraum4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_tatsachlichearbeitstageindiesemzeitraum4 = /** @type {((inputs?: _Field_Tatsachlichearbeitstageindiesemzeitraum4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Tatsachlichearbeitstageindiesemzeitraum4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Arbeitstage im Zeitraum")
});
export { _field_tatsachlichearbeitstageindiesemzeitraum4 as "_field_tatsachlicheArbeitstageInDiesemZeitraum" }